// extracted by mini-css-extract-plugin
export default {"details":"A6CrV5kgNM","details-dropdown":"RalNQdVVRv","detailsDropdown":"RalNQdVVRv","details-button":"_3PF+89zFrM","detailsButton":"_3PF+89zFrM"};
    if(module.hot) {
      // 1648554131848
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  